import { IAzureSearchOptions } from '@vivli/features/search/infrastructure/interface';
import { IAzureSearchApiOptions } from '@vivli/core/infrastructure/interface';

export const useAzureSearchOptions = ({ config, indexName }: IAzureSearchApiOptions) => {
    const searchOptions: IAzureSearchOptions = {
        assignedAppType: null,
        searchText: '*',
        skip: 0,
        top: 10,
        filterSets: null,
        select: null,
        filter: null,
        orderBy: null
    };

    const apiVersion = '2016-09-01';
    const params = new URLSearchParams();
    params.append('api-key', config?.queryKey);
    params.append('api-version', apiVersion);

    const apiOptions = {
        endpoint: `${config?.queryUri}/indexes/${indexName}/docs`,
        params
    };

    return {
        searchOptions,
        apiOptions
    };
};
